import { render, staticRenderFns } from "./WhaleioValues.vue?vue&type=template&id=7339195e&"
import script from "./WhaleioValues.vue?vue&type=script&lang=js&"
export * from "./WhaleioValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports